<template>
  <div class="mid-card-wrap">
    <div class="header-title-wrap">
      <span class="title">学院总体分析</span>
    </div>
    <div class="progress-title-wrap mid-title">{{ currentCollege }}</div>
    <div class="mid-analysis-main-wrap">
      <div class="analysis-left-wrap">
        <div class="analysis-left-top-wrap">
          <div class="top-item" v-for="item in totalList" :key="item.name">
            <span>{{ item.name }}<span class="suffix">/件数</span></span>
            <span class="analysis-text">
              <animate-number
                from="0"
                :to="item.value"
                :key="item.value"
                easing="easeOutQuad"
                duration="500"
              ></animate-number>
            </span>
            <ChangeCard name="同比增长" :value="item.increase"></ChangeCard>
          </div>
        </div>
        <div class="analysis-bottom-item">
          <div class="legend-wrap">
            <div class="legend-item" v-for="item in legends" :key="item.name">
              <span>{{ item.name }}</span>
              <span class="colors" :style="{ background: item.color }"></span>
            </div>
          </div>
          <span class="current-selected-item">{{ currentCollege }}</span>
          <div class="bar-item-wrap1">
            <div class="bar-item">
              <div class="item">
                <div class="number">{{ operaNum[0] }}</div>
                <div class="bar" :style="{ height: `${operaNum[0]}%` }"></div>
              </div>
              <div class="item">
                <div class="number">{{ operaNum[1] }}</div>
                <div class="bar" :style="{ height: `${operaNum[1]}%` }"></div>
              </div>
            </div>
            <div class="bar-name">合作数</div>
          </div>
          <div class="bar-item-wrap2">
            <div class="bar-item">
              <div class="item">
                <div class="number">{{ transNum[0] }}</div>
                <div class="bar" :style="{ height: `${transNum[0]}%` }"></div>
              </div>
              <div class="item">
                <div class="number">{{ transNum[1] }}</div>
                <div class="bar" :style="{ height: `${transNum[1]}%` }"></div>
              </div>
            </div>
            <div class="bar-name">转移转化</div>
          </div>
          <div class="bar-item-wrap3">
            <div class="bar-item">
              <div class="item">
                <div class="number">{{ keepNum[0] }}</div>
                <div class="bar" :style="{ height: `${keepNum[0]}%` }"></div>
              </div>
              <div class="item">
                <div class="number">{{ keepNum[1] }}</div>
                <div class="bar" :style="{ height: `${keepNum[1]}%` }"></div>
              </div>
            </div>
            <div class="bar-name">维持数</div>
          </div>
        </div>
      </div>
      <div class="analysis-right-wrap">
        <div
          class="menu-item"
          :class="{ active: currentSelect === item.id }"
          v-for="(item, index) in dataList"
          :key="item.id"
          @click="changecollege(item, index)"
        >
          <span class="name">{{ item.ORG }}</span>
          <span class="label">{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="bottom-analysis-wrap">
      <div class="progress-title-wrap">数据分析</div>
      <div
        class="bottom-analysis-progress-wrap"
        v-for="(item, index) in patentTypeList"
        :key="index"
      >
        <span>{{ index === 0 ? "专利类型" : "转化运营" }}</span>
        <span class="content-wrap">
          <span
            class="part-wrap"
            v-for="(i, index) in item"
            :key="i.name"
            :style="{ width: i.percent + '%' }"
          >
            <div class="text" v-if="i.percent >= 9">{{ i.name }}</div>
            <div class="empty" v-else></div>
            <div class="progress-item" :class="getProgress(index)"></div>
          </span>
        </span>
      </div>
      <div class="last-circle-wrap">
        <div class="circle-item">
          <ePie ref="pie1" :options="pie1Option"></ePie>
        </div>
        <div class="line"></div>
        <span class="circle-item">
          <ePie ref="pie2" :options="pie2Option"></ePie>
        </span>
        <div class="line"></div>
        <span class="circle-item">
          <ePie ref="pie3" :options="pie3Option"></ePie>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
const TEMPLATEID = process.env.VUE_APP_BASE_TEMPLATEID
import ChangeCard from './ChangeCard.vue'
import ePie from '@/components/BigScreen/Pie'
import { getGrowthData } from '@/api/databaseBin'
import dayjs from 'dayjs'
const currentYear = dayjs().format('YYYY')
const legends = [
  { name: `${currentYear-2}年`, color: '#00FFFF' },
  { name: `${currentYear-1}年`, color: '#E6D007' }
]

const pie3 = [
  { value: '56', name: 'WO' },
  { value: '24', name: 'EP' },
  { value: '20', name: 'JP' }
]

export default {
  props: {
    dataList: Array,
    date: String
  },
  data() {
    return {
      totalList: [
        { name: '专利申请', value: 0, increase: '15.8%' },
        { name: '专利授权', value: 0, increase: '9.6%' },
        { name: '专利有效', value: 0, increase: '12.6%' }
      ],
      patentTypeList: [],
      legends,
      currentSelect: 1,
      currentCollege: '',
      pie1Option: {}, // 第一个饼图的配置
      pie2Option: {}, // 第二个饼图的配置
      pie3Option: {}, // 第三个饼图的配置
      timer1: null,
      timer2: null,
      timer3: null,
      number: 0,
      hasRemind: false,
      inventionParams: {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20
          },
          querys: [
            {
              group: 'main',
              operation: 'EQUAL',
              property: 'F_TYPE',
              relation: 'AND',
              value: 'invent'
            },
            {
              group: 'main',
              operation: 'BETWEEN',
              property: 'F_PUBLICATION_DATE',
              relation: 'AND',
              value: ['1986-01-01', this.date]
            }
          ]
        },
        templateId: TEMPLATEID
      },
      newKindParams: {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20
          },
          querys: [
            {
              group: 'main',
              operation: 'EQUAL',
              property: 'F_TYPE',
              relation: 'AND',
              value: 'newKind'
            },
            {
              group: 'main',
              operation: 'BETWEEN',
              property: 'F_PUBLICATION_DATE',
              relation: 'AND',
              value: ['1986-01-01', this.date]
            }
          ]
        },
        templateId: TEMPLATEID
      },
      exteriorParams: {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20
          },
          querys: [
            {
              group: 'main',
              operation: 'EQUAL',
              property: 'F_TYPE',
              relation: 'AND',
              value: 'exterior'
            },
            {
              group: 'main',
              operation: 'BETWEEN',
              property: 'F_PUBLICATION_DATE',
              relation: 'AND',
              value: ['1986-01-01', this.date]
            }
          ]
        },
        templateId: TEMPLATEID
      },
      transferParams: {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20
          },
          querys: [
            {
              group: 'main',
              operation: 'LIKE',
              property: 'F_TAG_STAT',
              relation: 'AND',
              value: '转让'
            },
            {
              group: 'main',
              operation: 'BETWEEN',
              property: 'F_PUBLICATION_DATE',
              relation: 'AND',
              value: ['1986-01-01', this.date]
            }
          ]
        },
        templateId: TEMPLATEID
      },
      permitParams: {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20
          },
          querys: [
            {
              group: 'main',
              operation: 'LIKE',
              property: 'F_TAG_STAT',
              relation: 'AND',
              value: '许可'
            },
            {
              group: 'main',
              operation: 'BETWEEN',
              property: 'F_PUBLICATION_DATE',
              relation: 'AND',
              value: ['1986-01-01', this.date]
            }
          ]
        },
        templateId: TEMPLATEID
      },
      pledgeParams: {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20
          },
          querys: [
            {
              group: 'main',
              operation: 'LIKE',
              property: 'F_TAG_STAT',
              relation: 'AND',
              value: '质押'
            },
            {
              group: 'main',
              operation: 'BETWEEN',
              property: 'F_PUBLICATION_DATE',
              relation: 'AND',
              value: ['1986-01-01', this.date]
            }
          ]
        },
        templateId: TEMPLATEID
      },
      transNum: [],
      operaNum: [],
      keepNum: []
    }
  },
  components: {
    ChangeCard,
    ePie
  },
  created() {
    this.initSetting()
  },
  mounted() {
    this.getPieOptions3(pie3) // 获取第一个饼图的配置
  },
  watch: {
    dataList: {
      handler(val) {
        //
        if (val.length === 0) return;
        (this.totalList = [
          {
            name: '专利申请',
            value: val[0].application_num_total,
            increase: `${val[0].application_radio}%`
          },
          {
            name: '专利授权',
            value: val[0].authorize_num_total,
            increase: `${val[0].authorize_radio}%`
          },
          {
            name: '专利有效',
            value: val[0].effective_num_total,
            increase: `${val[0].effective_radio}%`
          }
        ]),
        (this.currentCollege = val[0].ORG)
        this.operaNum = [val[0].preOperaYear, val[0].curOperaYear]
        this.transNum = [val[0].preTranYear, val[0].curTranYear]
        this.keepNum = [val[0].preKeepYear, val[0].curKeepYear]
        this.timer1 = setTimeout(() => {
          this.number++
        }, 20000)
      },
      immediate: true,
      deep: true
    },
    number(val) {
      this.changeFakeData(this.dataList[val])
      this.timer2 = setTimeout(() => {
        this.commonChange()
      }, 20000)
    }
  },
  destroyed() {
    clearTimeout(this.timer1)
    clearTimeout(this.timer2)
    clearTimeout(this.timer3)
  },
  methods: {
    commonChange() {
      if (this.number === this.dataList.length - 1) {
        this.number = 0
      } else {
        this.number++
      }
    },
    initSetting() {
      // const { total: inventionValue } = await getGrowthData(this.inventionParams)
      //
      // const { total: newKindValue } = await getGrowthData(this.newKindParams)
      //
      // const { total: exteriorValue } = await getGrowthData(this.exteriorParams)
      //
      Promise.all([
        getGrowthData(this.inventionParams),
        getGrowthData(this.newKindParams),
        getGrowthData(this.exteriorParams)
      ]).then((res) => {
        const allTotal = res[0].total + res[1].total + res[2].total
        const inventRadio = (
          (res[0].total / allTotal).toFixed(2) * 100
        ).toFixed(0)
        const newKindRadio = (
          (res[1].total / allTotal).toFixed(2) * 100
        ).toFixed(0)
        const exteriorRadio = (
          (res[2].total / allTotal).toFixed(2) * 100
        ).toFixed(0)
        this.patentTypeList.push([
          { name: '发明专利', percent: inventRadio },
          { name: '实用新型', percent: newKindRadio },
          { name: '外观设计', percent: exteriorRadio }
        ]),
        (this.pie1 = [
          { value: inventRadio, name: '发明专利' },
          { value: newKindRadio, name: '实用新型' },
          { value: exteriorRadio, name: '外观设计' }
        ])
        this.getPieOptions1(this.pie1) // 获取第一个饼图的配置
      })
      Promise.all([
        getGrowthData(this.transferParams),
        getGrowthData(this.permitParams),
        getGrowthData(this.pledgeParams)
      ]).then((res) => {
        const allTotal = res[0].total + res[1].total + res[2].total
        const transferRadio = (
          (res[0].total / allTotal).toFixed(2) * 100
        ).toFixed(0)
        const permitRadio = (
          (res[1].total / allTotal).toFixed(2) * 100
        ).toFixed(0)
        const pledgeRadio = (
          (res[2].total / allTotal).toFixed(2) * 100
        ).toFixed(0)
        this.patentTypeList.push([
          { name: '转让', percent: transferRadio },
          { name: '许可', percent: permitRadio },
          { name: '质押', percent: pledgeRadio }
        ]),
        (this.pie2 = [
          { value: transferRadio, name: '转让' },
          { value: permitRadio, name: '许可' },
          { value: pledgeRadio, name: '质押' }
        ])
        this.getPieOptions2(this.pie2) // 获取第二个饼图的配置
      })
    },
    changeFakeData(item) {
      const {
        id,
        ORG,
        application_num_total,
        authorize_num_total,
        effective_num_total,
        application_radio,
        authorize_radio,
        effective_radio,
        preTranYear,
        preKeepYear,
        preOperaYear,
        curKeepYear,
        curOperaYear,
        curTranYear
      } = item
      this.transNum = [
        preTranYear, curTranYear
      ]
      this.operaNum = [
        preOperaYear, curOperaYear
      ]
      this.keepNum = [
        preKeepYear, curKeepYear
      ]
      // this.number = id - 1;
      this.currentSelect = id
      this.currentCollege = ORG
      this.totalList = [
        { name: '专利申请', value: application_num_total, increase: `${application_radio}%` },
        { name: '专利授权', value: authorize_num_total, increase: `${authorize_radio}%` },
        { name: '专利有效', value: effective_num_total, increase: `${effective_radio}%` }
      ]
      this.$emit('changeData')
    },
    changecollege(item, index) {
      clearTimeout(this.timer1)
      clearTimeout(this.timer2)
      clearTimeout(this.timer3)
      clearTimeout(this.timer4)
      if (this.number !== index) {
        this.timer3 = setTimeout(() => {
          this.number = index
        }, 0)
      } else {
        this.timer4 = setTimeout(() => {
          this.commonChange()
        }, 20000)
      }

      this.changeFakeData(item)
    },
    getProgress(index) {
      return 'part' + (index + 1)
    },
    getPieOptions1(data) {
      this.pie1Option = this.getOpt(data)
      this.$nextTick(() => {
        this.$refs.pie1.initChart()
      })
    },
    getPieOptions2(data) {
      this.pie2Option = this.getOpt(data)
      this.$nextTick(() => {
        this.$refs.pie2.initChart()
      })
    },
    getPieOptions3(data) {
      this.pie3Option = this.getOpt(data)
      this.$nextTick(() => {
        this.$refs.pie3.initChart()
      })
    },
    // 获取配置
    getOpt(data) {
      const colorList = ['#0167E6', '#00FFFF', '#FFFFFF']
      return {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'middle',
          right: '0',
          orient: 'vertical',
          textStyle: {
            color: '#fff'
          },
          icon: 'circle',
          itemWidth: 8,
          formatter: function (name) {
            const v = data.find((i) => i.name === name).value
            return `${name} ${v}%`
          }
        },
        series: [
          {
            type: 'pie',
            name: '专利',
            radius: ['30%', '40%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              formatter: function (name) {
                const { name: value } = name

                if (value === 'WO') {
                  return '国际'
                } else if (value === '发明专利') {
                  return '专利'
                } else {
                  return '运营'
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '11'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ],
        color: colorList
      }
    }
  }
}
</script>
